export default {
  methods: {
    addValue (cls, value) {
      document.getElementsByClassName('vdatetime-input')[0].placeholder = value
    }
  }
}
